// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const articuno_galar: PokeData = {
  "id": 10169,
  "name": "articuno-galar",
  "height": 17,
  "weight": 509,
  "base_experience": 290,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "confusion",
    "hypnosis",
    "agility",
    "double-team",
    "recover",
    "reflect",
    "dream-eater",
    "mind-reader",
    "ancient-power",
    "future-sight",
    "tailwind",
    "psycho-shift",
    "psycho-cut",
    "trick-room",
    "hurricane",
    "freezing-glare"
  ],
  "moves": [
    "gust",
    "reflect",
    "ancient-power",
    "future-sight",
    "tailwind",
    "hurricane",
    "acrobatics",
    "kinesis",
    "brave-bird",
    "psychic",
    "synchronize",
    "aerial-ace",
    "roost"
  ],
  "evolution_chain": {
    "id": 73,
    "item": null,
    "species": [
      {
        "name": "articuno",
        "order": 176,
        "types": [
          PokeType.ICE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 122,
    "ability_power": 161
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
